import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Form } from 'antd'
import {
  useGetResultInfo,
  useGetAttackType,
  useGetAttck,
  useGetUseCaseList,
  useUpdateResourceInterceptStatus,
  useGetTagTreeOptions,
  useGetOfflineLogImportInfo,
  useGetResourceFilterData,
  useGetDeviceProtectionList,
  useGetAttackDefenseRanking,
  useGetRiskLevelDistribution,
  useGetResourceLevelsRanking,
  useGetTemplateLoseEfficacyRanking,
  useGetVerifyDistribution,
  useAddReport,
  useDeleteList,
  useGetResultPluginDetail,
  useGetAttackOrganizationFilterData,
  useGetTemplateFilterData,
  useGetCancelValidCaseList,
  useGetSentFailedCaseList,
  useGetUnsentCaseList,
  useDeleteOfflineLogImportInfo,
} from './utils'

export const useTaskDetailHooks = () => {
  const [form] = Form.useForm()
  const [searchParams] = useSearchParams()
  const id = searchParams.get('id') as string
  const taskId = searchParams.get('task_id') as string

  // API hooks
  const [getTaskInfo, taskInfo] = useGetResultInfo()
  const [getAttackType, attackType] = useGetAttackType()
  const [getAttck, attckList] = useGetAttck()

  const [getUseCaseList, loading] = useGetUseCaseList()
  const [updateResourceInterceptStatus, updateInterceptStatusLoading] =
    useUpdateResourceInterceptStatus()
  const [getTagTreeOptions, tagTreeOptions] = useGetTagTreeOptions()
  const [getOfflineLogInfo, importRecord] = useGetOfflineLogImportInfo()
  // 删除日志设备导入记录
  const [deleteOfflineLogInfo, deleteRecordLoading] = useDeleteOfflineLogImportInfo()
  const [getResourceFilterData, resourceFilterData] = useGetResourceFilterData()
  const [getDeviceProtectionList, deviceProtectionList] = useGetDeviceProtectionList()
  const [getAttackDefenseRanking, attackDefenseRanking] = useGetAttackDefenseRanking()
  const [getRiskLevelDistribution, riskLevelDistribution] = useGetRiskLevelDistribution()
  const [getResourceLevelsRanking, resourceLevelsRanking] = useGetResourceLevelsRanking()
  const [getTemplateLoseEfficacyRanking, templateLoseEfficacyRanking] =
    useGetTemplateLoseEfficacyRanking()
  const [getVerifyDistribution, verifyDistribution] = useGetVerifyDistribution()
  const [generateReport, createLoading] = useAddReport()
  const [deleteTask] = useDeleteList()
  const [getResultPluginDetail, data, detailLoading] = useGetResultPluginDetail()
  const [getAttackOrganizationFilterData, attackOrganizationFilterData] =
    useGetAttackOrganizationFilterData()
  const [getTemplateFilterData, templateFilterData] = useGetTemplateFilterData()
  const [getCancelValidCaseList, cancelValidCaseList] = useGetCancelValidCaseList()
  const [getSentFailedCaseList, sentFailedCaseList] = useGetSentFailedCaseList()
  const [getUnsentCaseList, unsentCaseList] = useGetUnsentCaseList()

  return {
    form,
    id,
    taskId,
    getTaskInfo,
    taskInfo,
    getAttackType,
    attackType,
    getAttck,
    attckList,
    getUseCaseList,
    loading,
    updateResourceInterceptStatus,
    updateInterceptStatusLoading,
    getTagTreeOptions,
    tagTreeOptions,
    getOfflineLogInfo,
    importRecord,
    getResourceFilterData,
    resourceFilterData,
    getDeviceProtectionList,
    deviceProtectionList,
    getAttackDefenseRanking,
    attackDefenseRanking,
    getRiskLevelDistribution,
    riskLevelDistribution,
    getResourceLevelsRanking,
    resourceLevelsRanking,
    getTemplateLoseEfficacyRanking,
    templateLoseEfficacyRanking,
    getVerifyDistribution,
    verifyDistribution,
    generateReport,
    createLoading,
    deleteTask,
    getResultPluginDetail,
    data,
    detailLoading,
    getAttackOrganizationFilterData,
    attackOrganizationFilterData,
    getTemplateFilterData,
    templateFilterData,
    getCancelValidCaseList,
    cancelValidCaseList,
    getSentFailedCaseList,
    sentFailedCaseList,
    getUnsentCaseList,
    unsentCaseList,
    deleteOfflineLogInfo,
    deleteRecordLoading,
  }
}

export const useTaskDetailState = () => {
  const [executeTimeId, setExecuteTimeId] = useState('')
  const [logInfo, setLogInfo] = useState<{ visible: boolean; content: string }>({
    visible: false,
    content: '',
  })
  const [failLogInfo, setFailLogInfo] = useState<{ visible: boolean; content: [] }>({
    visible: false,
    content: [],
  })
  const [filterParams, setFilterParams] = useState({
    page: 1,
    limit: 20,
  })
  const [filterFormValue, setFilterFormValue] = useState<{
    field: string | number
    value: string | number | string[] | number[] | undefined
  }>({
    field: '',
    value: '',
  })
  const [useCaseList, setUseCaseList] = useState<any[]>([])
  const [useCaseTotal, setUseCaseTotal] = useState(0)
  const [fixPayloadCount, setFixPayloadCount] = useState(0)
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([])
  const [random, setRandom] = useState(0)
  const [cardActive, setCardActive] = useState('')
  const [importVisible, setImportVisible] = useState(false)
  const [reportVisible, setReportVisible] = useState({
    visible: false,
    result_id: '',
    name: '',
  })
  const [active, setActive] = useState<string>()
  const [deleteVisible, setDeleteVisible] = useState(false)
  const [detailDrawerVisible, setDetailDrawerVisible] = useState(false)
  const [pluginDetail, setPluginDetail] = useState<any>()
  const [fixedModalVisible, setFixedModalVisible] = useState(false)
  const [riskLevelSelectOpen, setRiskLevelSelectOpen] = useState(false)
  const [attackTypeSelectOpen, setAttackTypeSelectOpen] = useState(false)
  const [resourceLevelSelectOpen, setResourceLevelSelectOpen] = useState(false)
  const [interceptStatusSelectOpen, setInterceptStatusSelectOpen] = useState(false)
  const [deviceStatusSelectOpen, setDeviceStatusSelectOpen] = useState(false)
  const [infoActiveTab, setInfoActiveTab] = useState('taskTemplate')
  const [activeTab, setActiveTab] = useState('failed')
  const [progressContentList, setProgressContentList] = useState<any[]>([])
  const [recordVisible, setRecordVisible] = useState(false)
  const [verificationMode, setVerificationMode] = useState('1')

  return {
    executeTimeId,
    setExecuteTimeId,
    logInfo,
    setLogInfo,
    failLogInfo,
    setFailLogInfo,
    filterParams,
    setFilterParams,
    filterFormValue,
    setFilterFormValue,
    useCaseList,
    setUseCaseList,
    useCaseTotal,
    setUseCaseTotal,
    fixPayloadCount,
    setFixPayloadCount,
    selectedRowKeys,
    setSelectedRowKeys,
    random,
    setRandom,
    cardActive,
    setCardActive,
    importVisible,
    setImportVisible,
    reportVisible,
    setReportVisible,
    active,
    setActive,
    deleteVisible,
    setDeleteVisible,
    detailDrawerVisible,
    setDetailDrawerVisible,
    pluginDetail,
    setPluginDetail,
    fixedModalVisible,
    setFixedModalVisible,
    riskLevelSelectOpen,
    setRiskLevelSelectOpen,
    attackTypeSelectOpen,
    setAttackTypeSelectOpen,
    resourceLevelSelectOpen,
    setResourceLevelSelectOpen,
    interceptStatusSelectOpen,
    setInterceptStatusSelectOpen,
    deviceStatusSelectOpen,
    setDeviceStatusSelectOpen,
    infoActiveTab,
    setInfoActiveTab,
    activeTab,
    setActiveTab,
    progressContentList,
    setProgressContentList,
    recordVisible,
    setRecordVisible,
    verificationMode,
    setVerificationMode,
  }
}
